import { DialogDesignTokens } from '@primeuix/themes/types/dialog';

export const DIALOG_STYLES: DialogDesignTokens = {
  title: {
    fontSize: '1.0625rem',
  },
  header: {
    padding: '1.09375rem',
  },
  content: {
    padding: '0rem 1.09375rem',
  },
  footer: {
    padding: '1.09375rem',
  },
};
